export type EventParticipationType = 'participant' | 'visitor' | null

type CandidateItem = {
    id?: string | number | null
    businessId?: string | number | null
}

type DirectoryUserLike = {
    businesses?: CandidateItem[] | null
    assignments?: CandidateItem[] | null
}

const normalizeId = (value: unknown) => String(value ?? '').trim()

export const extractUserBusinessIds = (user: DirectoryUserLike | null | undefined) => {
    const businesses = Array.isArray(user?.businesses) ? user.businesses : []
    const assignments = Array.isArray(user?.assignments) ? user.assignments : []
    const ids = new Set<string>()

    ;[...businesses, ...assignments].forEach((item) => {
        const id = normalizeId(item?.id ?? item?.businessId)
        if (id) ids.add(id)
    })

    return Array.from(ids)
}

export const resolveEventParticipationType = (
    userBusinessIds: Array<string | number | null | undefined>,
    exhibitorBusinessIds: Array<string | number | null | undefined>,
    visitorBusinessIds: Array<string | number | null | undefined>,
): EventParticipationType => {
    const userIds = new Set(userBusinessIds.map(normalizeId).filter(Boolean))
    if (!userIds.size) return null

    const exhibitorIds = new Set(exhibitorBusinessIds.map(normalizeId).filter(Boolean))
    const visitorIds = new Set(visitorBusinessIds.map(normalizeId).filter(Boolean))

    for (const id of userIds) {
        if (exhibitorIds.has(id)) return 'participant'
    }

    for (const id of userIds) {
        if (visitorIds.has(id)) return 'visitor'
    }

    return null
}
